import { Badge } from "./ui/badge";

const MAP = {
  active: "bg-green-100 text-green-800 border-green-200",
  inactive: "bg-zinc-100 text-zinc-600 border-zinc-200",
  purchase: "bg-amber-100 text-amber-800 border-amber-200",
  sale: "bg-blue-100 text-blue-800 border-blue-200",
  payment: "bg-rose-100 text-rose-800 border-rose-200",
  receipt: "bg-green-100 text-green-800 border-green-200",
  complete: "bg-green-100 text-green-800 border-green-200",
  completed: "bg-green-100 text-green-800 border-green-200",
  pending: "bg-amber-100 text-amber-800 border-amber-200",
  requested: "bg-purple-100 text-purple-800 border-purple-200",
  assigned: "bg-blue-100 text-blue-800 border-blue-200",
  accepted: "bg-violet-100 text-violet-800 border-violet-200",
  in_progress: "bg-violet-100 text-violet-800 border-violet-200",
  rejected: "bg-rose-100 text-rose-800 border-rose-200",
  cancelled: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export function StatusBadge({ value, testid }) {
  const cls = MAP[value] || "bg-zinc-100 text-zinc-700 border-zinc-200";
  return (
    <Badge
      data-testid={testid}
      variant="outline"
      className={`rounded-sm font-semibold uppercase text-[10px] tracking-wider ${cls}`}
    >
      {value}
    </Badge>
  );
}
